export enum RequirementAddModalTabEnums {
  Manual= 1,
  Acord= 2
}
